import select_modal from "./modal-select.json";
import duplicate_transactions from "./duplicate-transactions.json";
import share_transactions from "./share-transactions.json";
import table_settings from "./table-settings.json";
import transfer_funds from "./transfer-funds.json";
import language_change from "./language-change.json";
import privacy_settings from "./privacy.json";
import search_transactions from "./search.json";
import change_password from "./change-password.json";
import recurrence_settings from "./recurrence-settings.json";
import export_transactions from "./export-transactions.json";
import register_payment from "./register-payment.json";
import share_contact_info from "./share-contact-info.json";
import contact from "./contact.json";
import notifications from "./notifications-settings.json";
import network_profile from "./network-profile.json";
import passwordless_access from "./passwordless-access.json";
import custom_payment_method from "./custom-payment-method.json";
import edit_payment_method from "./edit-payment-method.json";
import startup_options from "./startup-options.json";
import chart_settings from "./chart-settings.json";

export default {
  select_modal,
  duplicate_transactions,
  share_transactions,
  table_settings,
  transfer_funds,
  language_change,
  privacy_settings,
  search_transactions,
  change_password,
  recurrence_settings,
  export_transactions,
  register_payment,
  share_contact_info,
  contact,
  notifications,
  network_profile,
  passwordless_access,
  custom_payment_method,
  edit_payment_method,
  startup_options,
  chart_settings,
};
